import React, { FC } from 'react';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';
import NCFileGeneralContent from './components/NCFileGeneralContent';
import { MACHINES_PAGES_CONTAINER_STYLES, SCREEN_PADDING_HORIZONTAL_FOR_PAGE } from '@v2/pages/common/constants/base.constants';
import { View } from 'react-native';
import { scale } from '@components/frame';

interface NCFileGeneralProps extends NavigationProps {}

const NCFileGeneral: FC<NCFileGeneralProps> = ({ lg }) => {
  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
      withDefaultComponent
    >
      <View style={[MACHINES_PAGES_CONTAINER_STYLES, {paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL_FOR_PAGE)}]}>
        <NCFileGeneralContent ncFileDataLoading={false} withImages />
      </View>
    </MachinesProvider>
  );
};

export { NCFileGeneral };
